import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';

// SWAL
import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styles: []
})
export class PerfilComponent implements OnInit {

  passwordActual: string;
  passwordNuevo: string;
  passwordNuevoConfirma: string;

  constructor(public _userService: UserService) { }

  ngOnInit() {
  }

  seleccionArchivo(event: any) {

  }

  actualizarPassword() {
    if (this.passwordNuevo !== this.passwordNuevoConfirma) {
      swal('Password Incorrecto', 'Las contraseñas nuevas no son idénticas.', 'error');
    } else {
      if (this.passwordNuevo.length < 5) {
        swal('Password Incorrecto', 'Las contraseñas deben tener por lo menos 5 caracteres.', 'error');
      } else {
        this._userService.cambiarPassword(this._userService.user, this.passwordActual, this.passwordNuevo).subscribe((resp: any) => {
          swal('Contraseña Cambiada', 'La contraseña ha sido cambiada satisfactoriamente.', 'success');
        });
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/perfil/perfil.component.ts